<template>
  <app-content class="report-view">
    <s-loader v-if="generalLoading" class="report-view__loader" size="lg" />
    <b-tabs v-else-if="tabs.length" v-model="tabIndex">
      <b-tab v-for="tab in tabs" :key="tab.name" :title="tab.title">
        <generic-assets-relation-tab
          :assets-relation.sync="assetsRelation[tab.name]"
          :loading="loadings[tab.name]"
          :additional-fields="pagedFilter.filter.additionalFields"
          @refresh-data="refreshData(tab.name, $event)"
        />
      </b-tab>
    </b-tabs>
    <s-empty-list v-else />
  </app-content>
</template>

<script>
import invert from 'lodash/invert';
import GenericAssetsRelationTab from '@/domain/components/generalPanel/reports/assetsRelation/GenericAssetsRelationTab';
import AssetService from '@/domain/services/generalPanel/reports/assetsRelation/assetList';
import storageManager from '@/services/sessionStorageManager';
import { AssetTypes } from 'sigma-mappings';
import { assetsTypesIds } from '@/domain/data/installation/assets';

export default {
  name: 'ReportView',
  components: {
    GenericAssetsRelationTab,
  },
  data: () => ({
    tabIndex: 0,
    generalLoading: false,
    tabs: [],
    loadings: {
      transformer: false,
      'circuit-breaker': false,
      disconnector: false,
    },
    assetsRelation: {
      transformer: {},
      'circuit-breaker': {},
      disconnector: {},
    },
    pagedFilter: {
      pageSize: 15,
      page: 1,
      filter: {
        additionalFields: [],
      },
    },
  }),
  computed: {
    allTabs() {
      return [
        {
          name: AssetTypes.TRANSFORMER,
          title: this.$t('enums.asset-info.asset-type.transformer'),
        },
        {
          name: AssetTypes.CIRCUIT_BREAKER,
          title: this.$t('enums.asset-info.asset-type.circuit-breaker'),
        },
        {
          name: AssetTypes.DISCONNECTOR,
          title: this.$t('enums.asset-info.asset-type.disconnector'),
        },
      ];
    },
  },
  created() {
    this.getSessionStorage();
    this.refreshDataByAssetTypeFilter();
  },
  methods: {
    getFilteredTabs() {
      return this.allTabs.filter(tab => this.showTab(tab));
    },
    showTab(tab) {
      const items = this.assetsRelation[tab.name];
      return !!(items.data || []).length;
    },
    refreshData(assetType, typePagedFilter) {
      const filter = { ...this.pagedFilter.filter, ...typePagedFilter.filter };
      const pagedFilter = { ...typePagedFilter, filter };
      this.loadings[assetType] = true;
      const getAssets = new Promise((resolve, reject) => {
        AssetService.getAssets(assetType, pagedFilter)
          .then((response) => {
            this.assetsRelation[assetType] = response;
            resolve();
          })
          .catch((err) => {
            reject(err);
          })
          .finally(() => {
            this.loadings[assetType] = false;
          });
      });
      return getAssets;
    },
    getSessionStorage() {
      if (!this.$route.query) return;
      const storageItem = storageManager.getItem(this.$route.query.filter);
      this.pagedFilter.filter = {
        ...this.pagedFilter.filter,
        ...this.tryJsonParse(storageItem),
      };
    },
    tryJsonParse(item) {
      try {
        return JSON.parse(item);
      } catch (e) {
        this.$pushAlert({
          message: this.$t('reports.filter-error'),
          type: 'warning',
        });
        return {};
      }
    },
    hasAnyResponse() {
      return (
        (Object.keys(this.assetsRelation[AssetTypes.TRANSFORMER]).length
          || Object.keys(this.assetsRelation[AssetTypes.CIRCUIT_BREAKER]).length
          || Object.keys(this.assetsRelation[AssetTypes.DISCONNECTOR]).length) > 0
      );
    },
    refreshDataByAssetTypeFilter() {
      const filteredAssetTypes = this.pagedFilter.filter.assetTypes || [];
      const assetTypesById = invert(assetsTypesIds);
      const promises = filteredAssetTypes
        .map(assetType => this.refreshData(assetTypesById[assetType], this.pagedFilter));
      this.generalLoading = true;
      Promise.all([...promises])
        .then(() => {
          if (this.hasAnyResponse()) {
            this.$pushAlert({ code: 'MS011' });
          } else {
            this.$pushAlert({ code: 'MA009' });
          }
        })
        .finally(async () => {
          await this.$nextTick();
          this.generalLoading = false;
          this.tabs = this.getFilteredTabs();
        });
    },
  },
};
</script>
